module.exports = __webpack_public_path__ + "src/assets/images/icons/common/header//icn-downloads-off.svg";